import React from "react";
import PopOverMenu from "../pop-over-menu/pop-over-menu";
import styles from "./style.module.css";
import { convertTo12HourFormat } from "../../helper";
import Loader from "../loader";
import { MONTHLY_TYPE, STATUS_AVAILABLE } from "../../constants";

const TeacherSlots = ({
  onSelect,
  selectedSlots,
  slots,
  loading,
  offerDetail,
  onSelectSameSlots,
  onCheckAllSameDaySlots,
}) => {
  const weekDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const renderSlots = (allSlots) => {
    if (!allSlots) return "No allSlots available";
    return allSlots?.map((slot, index) => {
      return (
        <span key={`slot-${index}`} className="d-block border-bottom py-2">
          <span className="d-block">
            <input
              className="me-2"
              disabled={slot.status !== STATUS_AVAILABLE}
              type="checkbox"
              checked={
                selectedSlots?.find((item) => item?.uuid === slot?.uuid)
                  ? true
                  : false
              }
              onChange={(e) => onSelect(e, slot)}
            />{" "}
            <span
              className={`text-capitalize badge ${
                slot.status !== STATUS_AVAILABLE ? "bg-danger" : "bg-success"
              }`}
            >{`${slot?.status}`}</span>
          </span>
          <span className="d-block">{`${convertTo12HourFormat(
            slot?.startTime
          )} - ${convertTo12HourFormat(slot?.endTime)}`}</span>
          {offerDetail?.offerType === MONTHLY_TYPE && (
            <span className="d-block">
              <input
                className="me-2"
                disabled={slot.status !== STATUS_AVAILABLE}
                type="checkbox"
                checked={
                  slot.status === STATUS_AVAILABLE &&
                  onCheckAllSameDaySlots(slot)
                }
                onChange={(e) => onSelectSameSlots(e, slot)}
              />{" "}
              Book for all {slot?.dayName}
            </span>
          )}
        </span>
      );
    });
  };
  return loading ? (
    <div className={`custom_text_center ${styles["container"]}`}>
      <Loader />
    </div>
  ) : slots?.length ? (
    <>
      <h5 className="my-3">Teacher Slots</h5>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-dark">
            <tr>
              <th>Days</th>
              {weekDays.map((day, index) => (
                <th key={index}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody className="border">
            {slots?.map((item, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}</td>
                {Object.entries(item).map(([date, slots], colIndex) => (
                  <td
                    key={colIndex}
                    className={`${
                      !slots || !slots?.length
                        ? "text-body-tertiary cursor-not-allowed"
                        : ""
                    }${
                      slots?.some((item1) =>
                        selectedSlots?.some(
                          (item2) => item1?.uuid === item2?.uuid
                        )
                      )
                        ? "text-green"
                        : ""
                    }`}
                  >
                    <span className="d-block font-size-13px">{date}</span>
                    <span className="d-block font-size-13px cursor_pointer">
                      {slots?.length ? (
                        <u>
                          <PopOverMenu
                            placement="bottom"
                            content={
                              <div className={styles["content"]}>
                                {renderSlots(slots)}
                              </div>
                            }
                            button={<span>View Slots</span>}
                          />
                        </u>
                      ) : (
                        ""
                      )}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  ) : (
    <div className={`custom_text_center ${styles["container"]}`}>
      No slots to display.
    </div>
  );
};

export default TeacherSlots;
